// @ts-nocheck

/**
 * * `template` - Template-Based
 * `ai_generation` - AI Generation
 */
export type StorefrontSessionGenerationModeEnum =
  typeof StorefrontSessionGenerationModeEnum[keyof typeof StorefrontSessionGenerationModeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontSessionGenerationModeEnum = {
  template: "template",
  ai_generation: "ai_generation",
} as const;
